const MODAL_TITLE = "Payment Summary";
const OK_BUTTON_TEXT = "Confirm Payment";

export { MODAL_TITLE, OK_BUTTON_TEXT };
